import { render, staticRenderFns } from "./BaseIconButtonAssignmentReturned.vue?vue&type=template&id=581749cc&scoped=true&"
import script from "./BaseIconButtonAssignmentReturned.vue?vue&type=script&lang=js&"
export * from "./BaseIconButtonAssignmentReturned.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "581749cc",
  null
  
)

export default component.exports